/**
 * BW20-D — small chip row for the labels deriveMealLabels() returns.
 * Light-gray background, dark text, no icons. Up to N labels per meal so
 * the slot card stays readable.
 */

import { MEAL_LABEL_COPY, type MealLabel } from "@/lib/meal-labels";

export function MealLabelChips({
  labels,
  max = 3,
}: {
  labels: MealLabel[];
  max?: number;
}) {
  if (labels.length === 0) return null;
  const visible = labels.slice(0, max);

  return (
    <ul
      style={{
        listStyle: "none",
        margin: 0,
        padding: 0,
        display: "flex",
        flexWrap: "wrap",
        gap: "var(--space-1)",
      }}
    >
      {visible.map((label) => (
        <li
          key={label.kind}
          style={{
            fontFamily: "var(--font-sans)",
            fontSize: "var(--type-micro)",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            background:
              label.tone === "neutral_warn"
                ? "var(--bg-2, #ececec)"
                : "var(--bg-2, #ececec)",
            color:
              label.tone === "neutral_warn"
                ? "var(--fg-2, #555)"
                : "var(--fg-1, #1a1a1a)",
            padding: "2px 8px",
            borderRadius: 999,
            border: "1px solid var(--bg-3, transparent)",
          }}
        >
          {MEAL_LABEL_COPY[label.kind]}
        </li>
      ))}
    </ul>
  );
}
